import axiosapi from './axiosAPI'


// Get All Rights
export const getAllMonitors = async (
    setMonitors,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/monitors");
        const data = res?.data?.data ? res.data.data : [];
        const mapped = Array.isArray(data) ? data.map((u) => ({
            ...u,
            name: `${u?.firstname || ""} ${u?.lastname || ""}`.trim(),
            namedistrict: `${(`${u?.firstname || ""} ${u?.lastname || ""}`.trim())}${u?.district ? ` - ${u.district}` : ""}`
        })) : [];
        setMonitors(mapped);

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Monitors");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Monitors");
		}
		
	}
	
};